import React, { useEffect, useMemo, useState } from 'react';
import { useIntl, connect } from 'umi';
import { Layout } from 'tea-component';
import Tabs from '@intelligence/components/NewIconTabs';

import TotalMarket from './TotalMarket';
import MobileGames from './MobileGames';
import PCGames from './PCGames';
import ConsoleGames from './ConsoleGames';

import { PAGE_GLOBAL_CONTEXT_NAME } from '../components/TopMarketGenreCore/constants';
import MarqueeBanner from '@intelligence/components/MarqueeBanner/index';

const { Content } = Layout;
const PER_TYPE = 'market';

const TopGenrePerMarket = (props: any) => {
  const { context, dispatch: globalDispatch } = props;

  const { formatMessage } = useIntl();
  const [activeId, setActiveId] = useState('TotalMarket');

  const tabs = [
    { id: 'TotalMarket', label: formatMessage({ id: 'dbi_global_view_total_market' }), component: <TotalMarket perType={PER_TYPE} /> },
    { id: 'MobileGames', label: formatMessage({ id: 'dbi_mobile_games' }), component: <MobileGames perType={PER_TYPE} /> },
    { id: 'PCGames', label: formatMessage({ id: 'dbi_pc_games' }), component: <PCGames perType={PER_TYPE} /> },
    { id: 'ConsoleGames', label: formatMessage({ id: 'dbi_console_games' }), component: <ConsoleGames perType={PER_TYPE} /> },
  ];

  const setGlobalDispatchInit = () => {
    // 离开页面的时候，lastPerType，筛选器重置标记要重置
    globalDispatch({
      type: `${PAGE_GLOBAL_CONTEXT_NAME}/setLastPerType`,
      payload: ''
    });
    globalDispatch({
      type: `${PAGE_GLOBAL_CONTEXT_NAME}/setFilterChangeBeforeFlag`,
      payload: false
    });
  }

  useEffect(() => {
    return () => {
      setGlobalDispatchInit();
    }
  }, []);

  return (
    <>
      <Content>
        <Content.Header title={formatMessage({ id: 'dbi_global_view_top_genre_per_market' })} className="contentHead-normal">
          <div className="header-tab">
            <Tabs
              ceiling
              newMarkIdsMappingKey="GlobalViewTopGenrePerMarket"
              tabs={tabs}
              animated={false}
              activeId={activeId}
              onActive={(tab) => {
                setActiveId(tab.id);
              }}
            />
          </div>
        </Content.Header>
        <Content.Body full>
          <MarqueeBanner />
          {tabs.map((e) => (
            <div key={e.id}>{e.id == activeId ? e.component : ''}</div>
          ))}
        </Content.Body>
      </Content>
    </>
  );
}

export default connect((state: any) => {
  return {
    context: state[PAGE_GLOBAL_CONTEXT_NAME]
  };
})(TopGenrePerMarket);
